import angular from 'angular';

import ForgotPasswordConfirmComponent from './forgot-password-confirm.cmpt';

export default angular
    .module('application.scene.identity.scene.forgot-password-confirm', [])
    .component(ForgotPasswordConfirmComponent.selector, ForgotPasswordConfirmComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.forgot-password.confirm', {
        url: '',
        template: '<db-a-forgot-password-confirm class="block-component"></db-a-forgot-password-confirm>'
    });
}




// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-confirm/index.js